<!DOCTYPE html>
<html class="default" lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Eden</title>
    <link
      href="https://fonts.googleapis.com/css?family=Lato:300,400,600,700&display=swap"
      rel="stylesheet"
    />
    <link rel="icon" href="/favicon.png" />
    <script type="module" src="/app/index.js"></script>
  </head>

  <body>
    <div id="root"></div>
  </body>
</html>
